const NextI18Next = require('next-i18next').default;

module.exports = new NextI18Next({
  defaultLanguage: 'ko',
  otherLanguages: ['en', 'ja'],
  localePath: 'public/static/locales',
  localeSubpaths: {
    en: 'en',
    ja: 'ja',
  },
  defaultNS: 'common',
  ns: ['common', 'index', 'login', 'myChannel', 'myAccount', 'error', 'invite', 'auth-success'],
  preload: ['ko', 'en', 'ja'],
  backend: {
    loadPath: '/static/locales/{{lng}}/{{ns}}.json',
  },
  browserLanguageDetection: true,
  serverLanguageDetection: true,
  fallbackLng: 'ko',
  load: 'languageOnly',
  strictMode: false,
  react: {
    wait: true,
    useSuspense: false,
  },
  detection: {
    order: ['cookie', 'localStorage', 'navigator'],
    caches: ['cookie', 'localStorage'],
    cookieMinutes: 160,
    cookieDomain: 'currentDomain',
  },
});
